<template>
  <svg
    :class="[iconClass, newClass]"
    :height="height"
    :width="width"
    aria-hidden="true"
    class="app-icon"
  >
    <use :xlink:href="href" xmlns:xlink="http://www.w3.org/1999/xlink" />
  </svg>
</template>

<script>
import { computed, defineComponent, reactive, toRefs } from 'vue'

export default defineComponent({
  name: 'IconTemplate',
  props: {
    name: {
      type: String,
      required: true,
    },
    width: {
      type: [Number, String],
      default: 14,
    },
    height: {
      type: [Number, String],
      default: 14,
    },
    newClass: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const data = reactive({
      href: computed(() => `#${props.name}`),
      iconClass: computed(() => `app-icon--${props.name}`),
    })

    return {
      ...toRefs(data),
    }
  },
})
</script>

<style lang="scss" scoped>
.app-icon {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
</style>
